import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { AbstractBiditComponent } from '../../abstract.bidit.component';
import { QuoteService } from '../../../../quote/services/quote.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { TaxOptionsDialogData } from '../../../models/taxoptions.dialog.interface';
import { JobService } from '../../../../job/services/job.service';
import { NgForm } from '@angular/forms';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-quote-tax-options',
  templateUrl: './quote-tax-options.dialog.html',
  styleUrls: ['./quote-tax-options.dialog.scss']
})
export class QuoteTaxOptionsDialog extends AbstractBiditComponent implements OnInit {
  quoteTaxOptions: TaxOptionsDialogData = {} as TaxOptionsDialogData;

  constructor(private quoteService: QuoteService, private jobService: JobService, public dialogRef: MatDialogRef<QuoteTaxOptionsDialog>,
    @Inject(MAT_DIALOG_DATA) public data: TaxOptionsDialogData, deviceDetectorService: DeviceDetectorService) {
    super(deviceDetectorService);
  }

  @Output() updated = new EventEmitter<TaxOptionsDialogData>();

  ngOnInit() {
    this.quoteTaxOptions = this.data as TaxOptionsDialogData;
    this.quoteTaxOptions.netTax_Total = this.quoteTaxOptions.netTax_Total ?? 0;

  }

  calcTaxTotals(taxData: TaxOptionsDialogData) {
    taxData.materialTax_Rate ?
      (this.quoteTaxOptions.materialTax_Total = (taxData.materialTax_Rate * this.quoteTaxOptions.material_Cost) / 100) :
      this.quoteTaxOptions.materialTax_Total = this.quoteTaxOptions.materialTax_Total != 0 ? +this.quoteTaxOptions.materialTax_Total : this.quoteTaxOptions.materialTax_Total = 0;

    taxData.laborTax_Rate ?
      (this.quoteTaxOptions.laborTax_Total = (taxData.laborTax_Rate * this.quoteTaxOptions.labor_Cost) / 100) :
      this.quoteTaxOptions.laborTax_Total = this.quoteTaxOptions.laborTax_Total != 0 ? +this.quoteTaxOptions.laborTax_Total : this.quoteTaxOptions.laborTax_Total = 0;

    taxData.otherTax_Rate ?
      (this.quoteTaxOptions.otherTax_Total = (taxData.otherTax_Rate * this.quoteTaxOptions.other_Cost) / 100) :
      this.quoteTaxOptions.otherTax_Total = this.quoteTaxOptions.otherTax_Total != 0 ? +this.quoteTaxOptions.otherTax_Total : this.quoteTaxOptions.otherTax_Total = 0;

    this.quoteTaxOptions.netTax_Total = +(this.quoteTaxOptions.materialTax_Total + this.quoteTaxOptions.laborTax_Total + this.quoteTaxOptions.otherTax_Total).toFixed(2);
  }

  cancelEdit() {
    var proceed = confirm($localize`Are you sure?`);
    if (!proceed) return;

    this.alertComplete(false);
    this.dialogRef.close();
  }

  save(form: NgForm) {
    this.errors = '';

    if (form.valid) {
      this.isRequesting = true;

      if (this.quoteTaxOptions.changeOrder_ID == null) {
        this.quoteService.saveQuoteTaxOptions(this.quoteTaxOptions)
          .pipe(finalize(() => this.isRequesting = false))
          .subscribe(
            {
              next: (result) => {
                if (result) {
                  this.alertComplete(true);
                  form.resetForm();
                  this.dialogRef.close(result);
                }
              },
              error: (error: string) => this.onError(error)
            });
      }
      else {
        this.jobService.saveTaxOptions(this.quoteTaxOptions)
          .pipe(finalize(() => this.isRequesting = false))
          .subscribe(
            {
              next: (result) => {
                if (result) {
                  this.alertComplete(true);
                  form.resetForm();
                  this.dialogRef.close(result);
                }
              },
              error: (error: string) => this.onError(error)
            });
      }
    }
  }
  materialTotalChanged() {
    this.quoteTaxOptions.materialTax_Rate = null;
  }

  laborTotalChanged() {
    this.quoteTaxOptions.laborTax_Rate = null;
  }

  otherTotalChanged() {
    this.quoteTaxOptions.otherTax_Rate = null;
  }

  alertComplete(success: boolean) {
    if (success)
      this.updated.emit(this.quoteTaxOptions);
  }
}
